import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button, TextButton } from '@xing-com/button';
import { useNavigate } from '@xing-com/crate-core-router';
import { trackBackToMainPage } from '@xing-com/crate-entity-pages-common/tracking';
import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';
import { IconArrowLeft } from '@xing-com/icons';

import * as Styled from './subpage-back-button.styles';

export const SubpageTopBack: FC = () => {
  const navigate = useNavigate();
  const { pageContext } = usePageContext();

  return (
    <TextButton
      size={'medium'}
      icon={IconArrowLeft}
      onClick={() => {
        navigate(pageContext.basePath + '/' + pageContext.pageSlug);
        trackBackToMainPage();
      }}
      data-cy="back_to_overview"
    >
      <FormattedMessage
        id={'EP_SUBPAGE_BACK'}
        defaultMessage={'EP_SUBPAGE_BACK'}
      />
    </TextButton>
  );
};

export const SubpageBottomBack: FC = () => {
  const navigate = useNavigate();
  const { pageContext } = usePageContext();

  return (
    <Styled.BottomBack>
      <Button
        size={'medium'}
        variant={'tertiary'}
        onClick={() =>
          navigate(pageContext.basePath + '/' + pageContext.pageSlug)
        }
      >
        <FormattedMessage
          id={'EP_SUBPAGE_BACK'}
          defaultMessage={'EP_SUBPAGE_BACK'}
        />
      </Button>
    </Styled.BottomBack>
  );
};
